export class SalesforceGetObjectDetailsResultPayload {
	objectFields: string[] = [];
}
